import { useCancelReasonCodes } from "@/features/Charting/RoomOptions/network/useCancelReasonCodes";
import type { UseFormReturn } from "react-hook-form";
import type { VisitClosureFormData, VisitClosureFormInput } from "../schemas";
import { RequiresLiveVisitRejectionContent } from "./RequiresLiveVisitRejectionContent";

interface RequiresLiveVisitStepProps {
  form: UseFormReturn<VisitClosureFormInput, unknown, VisitClosureFormData>;
}

export function RequiresLiveVisitStep({ form }: RequiresLiveVisitStepProps) {
  const { data: reasonCodes } = useCancelReasonCodes();
  const cancelReasonCode = form.watch("rejectAsyncVisit.cancelReasonCode");
  const cancelReasonText = form.watch("rejectAsyncVisit.cancelReasonText");

  return (
    <RequiresLiveVisitRejectionContent
      reasonCodes={reasonCodes?.cancelReasonCodes}
      cancelReasonCode={cancelReasonCode}
      onCancelReasonCodeChange={(value) =>
        form.setValue("rejectAsyncVisit.cancelReasonCode", value, {
          shouldDirty: true,
          shouldValidate: true,
        })
      }
      cancelReasonText={cancelReasonText}
      onCancelReasonTextChange={(value) =>
        form.setValue("rejectAsyncVisit.cancelReasonText", value, {
          shouldDirty: true,
        })
      }
      showSubmitButton={false}
    />
  );
}
